module.exports = __webpack_public_path__ + "img/cta-trains.e4bd4473.jpg";